import { useContext, useEffect, useState } from "react";
import { t } from "i18next";
import { Button, Card } from "react-bootstrap";
import { useParams } from "react-router-dom";
import useDetailsAction from "../actions/details/useDetailsAction";
import TemplateSelector from "@bloonde/cms/cms-templates/components/TemplateSelector";
import React from "react";
import GoBack from "@main/panel-components/GoBack";

function PageEditionPage(props: { title: string, propPageId?: any }) {
  const { title, propPageId } = props;

  let { pageId } = useParams();

  if (!pageId && propPageId) {
    pageId = propPageId
  }

  if (!pageId) {
    pageId = "0";
  }

  const {
    getFunction,
    onSubmitFunction,
    actionTemplate: detailsActionTemplate,
  } = useDetailsAction(parseInt(pageId));

  useEffect(() => {
    if (pageId !== "0") {
      getFunction(pageId);
    }
  }, [pageId]);

  const filters = { page_id: pageId };
  const formFilterValues = { page_id: pageId };
  const formDefaultValues = { page_id: pageId };
  const formWidgets = { reviewer_id: TemplateSelector };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="mb-5">
            <Card>
              <Card.Header>
                <Card.Title><GoBack /> {t(title)}</Card.Title>
              </Card.Header>

              <Card.Body>
                {detailsActionTemplate}
              </Card.Body>

              <Card.Footer>
                <Button variant="primary" onClick={onSubmitFunction}>
                  {t('save_changes')}
                </Button>
              </Card.Footer>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}

export default PageEditionPage;
